export default __webpack_public_path__ + "static/media/st-george.a71f91be.jpeg";